/*!
 * ORDER/Utils
 *
 * @author Andrew Hill
 */
module.exports = {
	removeSpace : function (str){
		return str.replace(" ", "");
	},
	
    restrictChars: function(t, pattern){
        var patterns = {
            number:     "0123456789",
            phone:      "()- 0123456789",
            alpha:      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ "    
        };
        
        var v = patterns[pattern];
        
        var w = "";
        
        for (i=0; i < t.value.length; i++) {
            x = t.value.charAt(i);
            if (v.indexOf(x,0) != -1)
            w += x;
        }
        
        t.value = w;
    },
    
    increment: function (diff, ele){
        var newVal = parseInt(ele.value) + parseInt(diff);
        
        if(newVal < 0){
        	ele.value = 0
        } else {
            ele.value = newVal;
        }
    }
};